import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class ChatReportService extends BaseService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  sendReportIssue(payload: FormData): Observable<any> {
    const uri = 'live-support/support-cases';
    return this.post<any, any>(uri, payload);
  }

  sendReportIssueToServiceNow(payload: FormData): Observable<any> {
    const uri = 'live-support/servicenow/incident';
    return this.post<any, any>(uri, payload);
  }
}
